import * as z from "zod/v4";

export const canStartPostPurchaseAbTest = {
  name: "canStartPostPurchaseAbTest" as const,
  input: z.null(),
  output: z.union([
    z.object({ canStart: z.literal(true) }),
    z.object({ canStart: z.literal(false), reason: z.string() }),
  ]),
};
export type CanStartPostPurchaseAbTestOutput = z.infer<
  typeof canStartPostPurchaseAbTest.output
>;
